import { _useClientSubscriptions } from './_client.subscriptions';
import { _useConversationSubscriptions } from './_conversation.subscriptions';
import { _useIdleDisconnect } from './_use-idle-disconnect';
import { _useSelfPresenceSync, _useTeamPresenceSync, _useUserPresenceSet } from './_use-presence-sync';
import { _useWeaveWebsocketNotifications } from './_use-weave-websocket-notifications';
import { _useUpdateUnreadMentionsCount } from './use-update-unread-mentions-count';

type Props = {
  orgId: string;
  clientUserId: string;
  activeConversationId: string | undefined;
};

/** Set up as a cache sync for incoming events */
export const _SubscriptionsManager = ({ orgId, activeConversationId, clientUserId }: Props) => {
  _useConversationSubscriptions(activeConversationId);
  _useClientSubscriptions();
  _useIdleDisconnect();
  _useUserPresenceSet(orgId);
  _useWeaveWebsocketNotifications({ orgId, clientUserId });
  // This hook manages the state update of mentions and its unread count
  _useUpdateUnreadMentionsCount();
  return null;
};
_SubscriptionsManager.displayName = '_SubscriptionsManager';
